<template>
  <div v-if="events.length > 0">
    <h6 class="text-gray pb-3">{{ title }}</h6>

    <template v-if="calendarType === calendarTypeEnum.day">
      <v-timeline width="400" side="end" dense>
        <TimeLine :events="eventsList" :calendarType="calendarType" :isSmall="false"></TimeLine>
      </v-timeline>
    </template>

    <template v-if="calendarType === calendarTypeEnum.week">
      <div class="flex-container">
        <TimeLine :events="weekEventsList.sunday" :calendarType="calendarType" :title="$t('GeneralTranslations.Sunday')" :isSmall="true"></TimeLine>
        <TimeLine :events="weekEventsList.monday" :calendarType="calendarType" :title="$t('GeneralTranslations.Monday')" :isSmall="true"></TimeLine>
        <TimeLine :events="weekEventsList.tuesday" :calendarType="calendarType" :title="$t('GeneralTranslations.Tuesday')" :isSmall="true"></TimeLine>
        <TimeLine :events="weekEventsList.wednesday" :calendarType="calendarType" :title="$t('GeneralTranslations.Wednesday')" :isSmall="true"></TimeLine>
        <TimeLine :events="weekEventsList.thursday" :calendarType="calendarType" :title="$t('GeneralTranslations.Thursday')" :isSmall="true"> </TimeLine>
        <TimeLine :events="weekEventsList.friday" :calendarType="calendarType" :title="$t('GeneralTranslations.Friday')" :isSmall="true"></TimeLine>
        <TimeLine :events="weekEventsList.saturday" :calendarType="calendarType" :title="$t('GeneralTranslations.Saturday')" :isSmall="true"></TimeLine>
      </div>
    </template>

    <template v-if="calendarType === calendarTypeEnum['4day']">
      <div class="flex-container">
        <TimeLine :events="fourDaysEvents.firstDay.events" :calendarType="calendarType" :title="$t('GeneralTranslations.' + fourDaysEvents.firstDay.name)" :isSmall="true"></TimeLine>
        <TimeLine :events="fourDaysEvents.secondDay.events" :calendarType="calendarType" :title="$t('GeneralTranslations.' + fourDaysEvents.secondDay.name)" :isSmall="true"></TimeLine>
        <TimeLine :events="fourDaysEvents.thirdDay.events" :calendarType="calendarType" :title="$t('GeneralTranslations.' + fourDaysEvents.thirdDay.name)" :isSmall="true"></TimeLine>
        <TimeLine :events="fourDaysEvents.fourthDay.events" :calendarType="calendarType" :title="$t('GeneralTranslations.' + fourDaysEvents.fourthDay.name)" :isSmall="true"></TimeLine>
      </div>
    </template>

  </div>
  <div v-else class="no-data py-4">
    <h5>{{$t('GeneralTranslations.NoData')}}</h5>
  </div>
</template>

<script>
import moment from 'moment';
import { mapState } from "vuex";
import { CalendarTypeEnum } from '@/enums/CalendarTypeEnum';
import { EventsTypes } from '@/enums/EventsTypes';
import TimeLine from "@/views/calender/schedule-view/TimeLine.vue";

export default {
  components: { TimeLine },
  props: {
    events: [],
    calendarType: {
      type: String,
      default: ''
    }
  },
  data() {
    return {
      calendarTypeEnum: CalendarTypeEnum,
      eventsList: [],
      weekEventsList: { sunday: [], monday: [], tuesday: [], wednesday: [], thursday: [], friday: [], saturday: [] },
      fourDaysEvents: { firstDay: { name: '', events: [] }, secondDay: { name: '', events: [] }, thirdDay: { name: '', events: [] }, fourthDay: { name: '', events: [] } }
    };
  },
  created() {
    if(this.calendarType !== CalendarTypeEnum.day && this.calendarType !== CalendarTypeEnum.week && this.calendarType !== CalendarTypeEnum['4day']){
      this.calendarType = CalendarTypeEnum.week
    }
  },
  computed: {
    ...mapState({
      facility: state => state.facilityModule.selectedFacility
    }),
    title() {

      if (this.calendarType === CalendarTypeEnum.day) {
        return `${this.events.length} ${this.$t('Calendar.EventsSheduledForToday')}`
      }

      if (this.calendarType === CalendarTypeEnum.week) {
        return `${this.events.length} ${this.$t('Calendar.EventsSheduledForThisWeek')}`
      }

      if (this.calendarType === CalendarTypeEnum['4day']) {
        return `${this.events.length} ${this.$t('Calendar.EventsSheduledForTheNextFourDays')}`
      }

      return `${this.events.length} event(s)`
    },
    reactiveEvents: {
      get() {
        return this.events;
      },
      set(newVal) {
        this.setEvents([...newVal]);
      }
    }
  },
  methods: {
    setEvents(events) {

      const sortedEvents = events.map(x => {
        const e = x
        e.icon = this.getEventIconByType(e.type)
        e.color = this.getEventColorByType(e.type)
        return e
      }).sort((a, b) => {
        return a.startDate - b.startDate;
      });


      if (this.calendarType === CalendarTypeEnum.day) {
        this.eventsList = []
        this.eventsList = sortedEvents;
      }

      if (this.calendarType === CalendarTypeEnum.week) {
        this.weekEventsList = { sunday: [], monday: [], tuesday: [], wednesday: [], thursday: [], friday: [], saturday: [] }

        sortedEvents.forEach(event => {
          const startDate = moment(event.startDate);
          const dayOfWeek = startDate.day();

          switch (dayOfWeek) {
            case 0:
              this.weekEventsList.sunday.push(event);
              break;
            case 1:
              this.weekEventsList.monday.push(event);
              break;
            case 2:
              this.weekEventsList.tuesday.push(event);
              break;
            case 3:
              this.weekEventsList.wednesday.push(event);
              break;
            case 4:
              this.weekEventsList.thursday.push(event);
              break;
            case 5:
              this.weekEventsList.friday.push(event);
              break;
            case 6:
              this.weekEventsList.saturday.push(event);
              break;
            default:
              break;
          }
        });
      }

      if (this.calendarType === CalendarTypeEnum['4day']) {
        this.fourDaysEvents = { firstDay: { name: '', events: [] }, secondDay: { name: '', events: [] }, thirdDay: { name: '', events: [] }, fourthDay: { name: '', events: [] } }

        sortedEvents.forEach(event => {
          const startDate = moment(event.startDate);
          const today = moment(sortedEvents[0].start).startOf('day');
          const diffDays = startDate.diff(today, 'days');

          if (diffDays >= 0 && diffDays <= 3) {
            const eventDay = diffDays + 1;
            const eventDayName = today.add(diffDays, 'days').locale('en').format('dddd');

            switch (eventDay) {
              case 1:
                this.fourDaysEvents.firstDay.name = eventDayName;
                this.fourDaysEvents.firstDay.events.push(event);
                break;
              case 2:
                this.fourDaysEvents.secondDay.name = eventDayName;
                this.fourDaysEvents.secondDay.events.push(event);
                break;
              case 3:
                this.fourDaysEvents.thirdDay.name = eventDayName;
                this.fourDaysEvents.thirdDay.events.push(event);
                break;
              case 4:
                this.fourDaysEvents.fourthDay.name = eventDayName;
                this.fourDaysEvents.fourthDay.events.push(event);
                break;
              default:
                break;
            }
          }
        });
      }

    },
    getEventIconByType(eventType) {
      if (eventType === EventsTypes.LifestylePrograms) {
        return 'mdi-basketball'
      }
      if (eventType === EventsTypes.Notice) {
        return 'mdi-note-edit'
      }
      if (eventType === EventsTypes.PremiumServices) {
        return 'mdi-star'
      }
      if (eventType === EventsTypes.ConciergeRequest) {
        return 'mdi-face-agent'
      }
      if (eventType === EventsTypes.Concierge) {
        return 'mdi-face-agent'
      }
      if (eventType === EventsTypes.FamilyVisit) {
        return 'mdi-book-open-variant'
      }
      if (eventType === EventsTypes.Medical) {
        return 'mdi-medical-bag'
      }
      if (eventType === EventsTypes.ScheduledCall) {
        return 'mdi-phone-clock'
      }
      if (eventType === EventsTypes.RealtimeCall) {
        return 'mdi-phone'
      }

      return 'mdi-calendar-blank-outline'
    },
    getEventColorByType(eventType) {

      if (eventType == EventsTypes.LifestylePrograms) return '#0D47A1'
      if (eventType == EventsTypes.PremiumServices) return '#4caf50'
      if (eventType == EventsTypes.Notice) return '#ff0000'
      if (eventType == EventsTypes.FamilyVisit) return '#4b0082'
      if (eventType == EventsTypes.Medical) return '#ffc0cb'
      if (eventType == EventsTypes.Concierge) return '#ffa500'
      if (eventType == EventsTypes.Meal) return '#009688'

      return '#ffa500'
    }
  },
  watch: {
    events: {
      handler(newEvents) {
        this.setEvents([...newEvents]);
      },
      immediate: true,
      deep: true
    }
  }
};
</script>

<style scoped>
.flex-container {
  flex-direction: row;
  scroll-snap-align: start;
  display: flex;
  width: 100%;
  overflow-x: scroll;
}
.no-data{
  justify-content: center;
  display: flex;
  color: #616161; 
}
</style>